document.addEventListener('DOMContentLoaded', function() {
  if (!getCookie('ageVerified')) {
    document.getElementById('age-checker').style.display = 'block';
  }
});

function verifyAge() {
  setCookie('ageVerified', 'true', 7); // Set a cookie for 7 days
  document.getElementById('age-checker').style.display = 'none';
}

function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
